{
  "changeChain": {
    "title": "Selecciona una cadena"
  },
  "checkoutBlocked": {
    "notAvailable": "No disponible",
    "regionMessage": "Este servicio no está disponible en tu región.",
    "viewRegions": "Ver regiones disponibles."
  },
  "common": {
    "addressCopied": "Dirección copiada",
    "back": "Atrás",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "confirm": "Confirmar",
    "continue": "Continuar",
    "copied": "¡Copiado!",
    "copy": "Copiar",
    "copyAddress": "Copiar dirección",
    "done": "Listo",
    "go": "Ir",
    "loading": "Cargando…",
    "ok": "Aceptar",
    "poweredBy": "con tecnología de",
    "tryAgain": "Intentar nuevamente",
    "startOver": "Empezar de nuevo"
  },
  "depositAmount": {
    "amountLabel": "Importe",
    "changeToMaximum": "Cambiar al máximo",
    "changeToMinimum": "Cambiar al mínimo",
    "delete": "Borrar",
    "enterAmount": "Introduce un importe",
    "fee": "Comisión de {{amount}}",
    "maximumAmount": "Depósito máximo {{amount}}",
    "minimumAmount": "Depósito mínimo {{amount}}",
    "title": "Depósito",
    "submit": "Depositar",
    "submitWithMethod": "Depositar con {{method}}"
  },
  "feeDetails": {
    "amount": "Importe",
    "fee": "Comisión del {{rate}}",
    "summaryAddedToCharge": "Los depósitos con {{method}} conllevan una comisión del {{rate}} que se sumará al cargo total.",
    "summaryDeductedFromDeposit": "Los depósitos con {{method}} conllevan una comisión del {{rate}} que se descontará del importe que recibes.",
    "title": "Detalles de la comisión",
    "totalCost": "Coste total",
    "youllGet": "Recibirás"
  },
  "fiat": {
    "agreeAndContinue": "Aceptar términos y continuar",
    "amountLabel": "Importe del depósito",
    "applePay": "Apple Pay",
    "applePayNotSetUp": "Añade una tarjeta a Apple Wallet y vuelve a intentarlo.",
    "applePayUnsupported": "Este dispositivo no puede pagar con Apple Pay.",
    "blocked": "Los depósitos no están disponibles en tu región",
    "card": "Tarjeta",
    "contactVerifyBoth": "Verifica tu número de teléfono y tu correo electrónico",
    "contactVerifyEmail": "Verifica tu correo electrónico",
    "contactVerifyPhone": "Verifica tu número de teléfono",
    "countryHeading": "Tu país",
    "countrySearchPlaceholder": "Buscar",
    "delete": "Borrar",
    "deposit": "Depositar",
    "depositReceived": "Depósito de {{amount}} recibido",
    "depositReceivedFrom": "de {{method}}",
    "emailPlaceholder": "Tu correo electrónico",
    "failure": "Depósito fallido",
    "fee": "Comisión de {{amount}}",
    "getNewPrice": "Obtener un nuevo precio",
    "kycConsentCheck": "Acepto que Fun verifique mi identidad y comparta el resultado con el proveedor de pago que completa mi pedido. Consulta nuestra",
    "kycConsentPrompt": "Al continuar, aceptas que Fun verifique tu identidad y comparta el resultado con el proveedor de pago que completa tu pedido. Consulta nuestra",
    "kycConsentStop": ".",
    "kycDetailAddress": "Indica tu dirección",
    "kycDetailDob": "Introduce tu fecha de nacimiento",
    "kycDetailName": "Necesitamos más información sobre tu identidad para proteger tu depósito.",
    "kycDetailNationality": "Tu nacionalidad",
    "kycDetailOther": "Proporciona los datos restantes",
    "kycDetailSsn": "Indica tu SSN de 9 dígitos",
    "kycFileUnsupported": "La carga de documentos aún no está disponible aquí; podrás completar este paso pronto.",
    "kycFormDetail": "Necesitamos algunos datos antes de tu primer depósito.",
    "kycFormInvalid": "Algunos de estos datos necesitan otra revisión.",
    "kycPhoneInUse": "Este número de teléfono ya se usa con otra cuenta de {{provider}}. Usa otro número.",
    "kycTaxIdInUse": "Este número fiscal ya se usa con otra cuenta de {{provider}}.",
    "kycFormMissing": "Faltan algunos datos obligatorios.",
    "kycFormStale": "Este paso ha cambiado. Revisa los datos siguientes.",
    "kycFormTitle": "Verifica tu identidad",
    "kycIntroDetail": "Esto nos permite procesar tus depósitos manteniendo tu cuenta segura. Solo toma un minuto y no se requieren documentos de identidad.",
    "kycNoticeCountryCode": "Usa el código de país de dos letras, como AU",
    "kycNoticeDateFormat": "Usa el formato AAAA-MM-DD",
    "kycNoticeDatePast": "Introduce una fecha pasada",
    "kycNoticeInvalid": "Revisa los campos resaltados",
    "kycNoticeRequired": "Completa los campos resaltados",
    "kycNoticeUnderage": "Debes tener al menos 18 años para continuar",
    "kycOnHold": "Verificación en espera",
    "kycOnHoldDetail": "Puedes volver e intentarlo de nuevo más tarde.",
    "kycOnHoldUntil": "Puedes volver a intentarlo el {{date}}.",
    "kycOpenLink": "Continuar verificación",
    "kycOptional": "opcional",
    "kycPrivacyPolicy": "Política de Privacidad",
    "kycProviderGeneric": "nuestro proveedor de pago",
    "kycProviderGenericId": "nuestro socio de verificación",
    "kycProviderTerms": "términos y condiciones de {{provider}}",
    "kycProviderTermsPrompt": "Al continuar, aceptas los",
    "kycRejected": "Verificación sin éxito",
    "kycRejectedSupport": "Contacta con soporte y lo revisaremos.",
    "kycRequired": "Verificar y depositar",
    "kycRequiredCta": "Verificación necesaria →",
    "kycRequiredDetail": "Completa la verificación para continuar con tu depósito.",
    "kycRequiredTitle": "Verificación de identidad requerida",
    "kycCompleteDetail": "Se ha aumentado tu límite de depósito.",
    "kycCompleteTitle": "Verificación de identidad completada",
    "kycHardCta": "Ver opciones →",
    "kycHardDetail": "No podemos aumentar tu límite de depósito con la verificación de identidad.",
    "kycHardTitle": "No podemos verificar tu identidad",
    "kycPendingCta": "Esperando verificación →",
    "kycPendingDetail": "Estamos trabajando para completar tu verificación lo antes posible.",
    "kycPendingTitle": "Verificación de identidad en curso",
    "kycSoftCta": "Verificación necesaria →",
    "kycSoftDetail": "Puedes intentarlo de nuevo para corregir los problemas de tu verificación.",
    "kycSoftTitle": "La verificación de identidad no funcionó",
    "kycOptionCloseDetail": "Sal y vuelve a este depósito más tarde.",
    "kycOptionCloseTitle": "Cerrar depósito",
    "kycOptionMaxDetail": "Hasta {{max}} antes de la verificación.",
    "kycOptionMaxDetailUnknown": "Hasta tu límite actual antes de la verificación.",
    "kycOptionMaxTitle": "Depositar el máximo",
    "kycOptionRedoDetail": "Confirma tus datos y documentación e inténtalo de nuevo.",
    "kycOptionRedoTitle": "Repetir la verificación de identidad",
    "kycOptionSupportDetail": "Contáctanos para resolver problemas relacionados con los requisitos de verificación de identidad.",
    "kycOptionSupportTitle": "Obtener ayuda y soporte",
    "kycOptionsHardTitle": "No podemos aumentar tu límite de depósito tras la verificación de identidad.",
    "kycOptionsLabel": "Ahora mismo puedes:",
    "kycOptionsPendingTitle": "Tu verificación de identidad aún se está procesando. Tus límites de depósito no han cambiado todavía.",
    "kycOptionsSoftTitle": "Tu verificación de identidad no funcionó. Inténtalo de nuevo para corregir posibles problemas del último intento.",
    "kycTitle": "Verificación de identidad",
    "otpDetailAnyEmail": "Código enviado a tu correo electrónico",
    "otpDetailAnyPhone": "Código enviado a tu teléfono",
    "otpDetailEmail": "Código enviado a {{email}}",
    "otpDetailPhone": "Código enviado a {{phone}}",
    "otpError": "Ese código no funcionó. Revísalo e intenta nuevamente.",
    "otpExpired": "Ese código ha caducado. Solicita uno nuevo.",
    "otpRateLimited": "Se solicitaron demasiados códigos. Espera antes de volver a intentarlo.",
    "otpRateLimitedTitle": "Espera antes de solicitar otro código",
    "otpPlaceholder": "Código de 6 dígitos",
    "otpResend": "Reenviar",
    "otpResendPrompt": "¿No recibiste el código?",
    "otpTitle": "Introduce el código",
    "payButton": "Depositar con Apple Pay",
    "paySheetPay": "Pagar",
    "paySheetTitle": "Confirmar con Apple Pay",
    "paySheetTotal": "Total {{amount}}",
    "phoneCountryLabel": "Código de país",
    "phoneCountrySearch": "Buscar países",
    "phonePlaceholder": "Tu número de teléfono",
    "processing": "Procesando tu depósito…",
    "pendingOrderTitle": "Tienes un depósito sin finalizar",
    "pendingOrderDetail": "Reanuda tu depósito de {{amount}} o cancélalo para continuar con un nuevo importe.",
    "resumeDeposit": "Reanudar depósito",
    "cancelDeposit": "Cancelar depósito",
    "quoteExpired": "Ese precio ha caducado",
    "quoteFailed": "No se pudo obtener el precio",
    "redirectDetail": "Actualizaremos esta pantalla en cuanto vuelvas.",
    "redirectReopen": "Abrir el navegador de nuevo",
    "redirectTitle": "Completa tu pago en el navegador",
    "refunded": "Depósito reembolsado",
    "refusalDetails": "Revisa lo que ingresaste e inténtalo de nuevo.",
    "refusalDetailsTitle": "Algunos de estos datos necesitan otra revisión",
    "refusalLimits": "Prueba con un importe menor u otro método de pago.",
    "refusalLimitsTitle": "Este método de pago no admite ese importe",
    "refusalUnavailable": "Es un problema nuestro: inténtalo de nuevo en un momento o prueba con un importe menor.",
    "refusalUnavailableTitle": "No hay ninguna opción de pago disponible ahora",
    "requote": "Obtener una nueva cotización",
    "reviewTitle": "Confirma tu depósito",
    "orderConfirmingTitle": "Confirmando tu pago",
    "orderConfirmingDetail": "Tu pago se realizó. Estamos registrando tu depósito; puede tardar un momento.",
    "submitFailed": "No se pudo completar",
    "paymentFailed": "Vuelve a intentarlo",
    "submitting": "Enviando",
    "stripeAuthDetail": "Usaremos {{email}} para continuar de forma segura con Link.",
    "stripeAuthorizing": "Continuar en Stripe",
    "stripeAuthorizingDetail": "Completa la verificación y el consentimiento de Link en la ventana de Stripe.",
    "stripeAuthTitle": "Continuar con Stripe",
    "stripeAuthFailed": "No pudimos iniciar tu sesión de Stripe. Inténtalo de nuevo.",
    "stripeKycInfoFailed": "No pudimos guardar tus datos en Stripe. Revísalos e inténtalo de nuevo.",
    "stripeRegistrationFailed": "No pudimos crear tu cuenta de Link. Revisa tus datos e inténtalo de nuevo.",
    "success": "Depósito completado",
    "successDetail": "Tu saldo se actualizará en un momento.",
    "termsNotice": "Al continuar, aceptas los\n<terms>Términos</terms> del proveedor.",
    "unsupported": "Este paso aún no está disponible",
    "verifying": "Verificando tu identidad…",
    "verifyingDetail": "Esto suele tardar menos de un minuto.",
    "verifyingSlow": "Seguimos verificando",
    "verifyingSlowDetail": "Puedes cerrar esto y volver en un momento.",
    "coinbaseTermsNotice": "Al continuar, aceptas los\n<terms>Términos</terms>, el <agreement>Acuerdo de usuario</agreement> y la <privacy>Política de privacidad</privacy> de Coinbase.",
    "contactInvalidEmail": "Introduce una dirección de correo válida",
    "kycIntroTitle": "Verifiquemos tu identidad",
    "kycAdditionalTitle": "Necesitamos un poco más de info",
    "kycAdditionalDetail": "Se requiere una verificación adicional para aumentar los límites de depósito. Los nuevos límites estarán disponibles en cuanto se complete la verificación.",
    "kycFindOutMore": "Más información",
    "kycR2Consent": "Al continuar, aceptas que Fun verifique tu identidad y comparta los resultados con determinados proveedores de pago.",
    "kycAgreeContinue": "Aceptar y continuar",
    "kycSsnLastFour": "Introduce los últimos\n4 dígitos de tu SSN",
    "kycSsnProtection": "La legislación estadounidense nos exige recopilar un SSN para verificar tu identidad. Tus datos están protegidos con cifrado de nivel bancario.",
    "kycDetailCountry": "Tu país",
    "kycCountry": "País",
    "kycDetailOccupation": "Tu ocupación",
    "kycDetailPurpose": "Indica el propósito de tu transacción",
    "kycOccupation": "Ocupación",
    "kycPurpose": "Propósito de la transacción",
    "kycDetailPhone": "Tu número de móvil",
    "kycDetailEmployment": "Tu situación laboral",
    "kycDetailSourceOfWealth": "El origen de tu patrimonio",
    "kycDetailIncome": "Tus ingresos brutos anuales",
    "kycDetailActivity": "Tu actividad mensual",
    "kycIncomeCaption": "Antes de impuestos, en tu moneda local",
    "kycReviewTitle": "¡Gracias! Hemos recibido tu información y la estamos revisando.",
    "kycHoldTitle": "¡Gracias! Hemos recibido tu información. Necesitamos un poco más de tiempo para completar la revisión.",
    "kycRestrictedTitle": "Tu cuenta ha sido restringida.",
    "regionUnsupportedTitle": "Tu región no es compatible.",
    "kycAnyQuestions": "¿Tienes alguna pregunta?",
    "kycGetHelpSupport": "Obtener ayuda y soporte",
    "otpVerified": "Código verificado",
    "authConnectFailedTitle": "No pudimos conectar tu cuenta de {{provider}}",
    "authConnectFailedDetail": "Empieza de nuevo para iniciar sesión desde el principio.",
    "kycUnavailableTitle": "La verificación no está disponible temporalmente.",
    "kycUnavailableNetwork": "Vuelve a intentarlo en un momento o regresa más tarde.",
    "kycUnavailableProviderTitle": "No pudimos verificar tu identidad.",
    "kycUnavailableProvider": "Ha ocurrido un problema por nuestra parte. Contacta con soporte y lo resolvemos.",
    "contactSupport": "Contactar con soporte",
    "kycDocumentTitle": "Verificamos tu identidad",
    "kycDocumentDetail": "Necesitamos comprobar tu identificación para completar tu verificación. La verificación de identidad funciona con {{provider}}.",
    "kycDocumentContinue": "Verificar identidad con {{provider}}",
    "applePayUnavailableTitle": "Apple Pay no está disponible temporalmente.",
    "kycLimitNotice": "Límite diario alcanzado: verifica tu identidad para aumentar tus límites al instante.",
    "contactEmailRejected": "No se puede verificar esta dirección de correo. Elige otra dirección.",
    "contactReverifyPhone": "Vuelve a verificar tu número de teléfono.",
    "coinbaseCardSoftDeclined": "Tu banco rechazó este pago. Prueba con otra tarjeta en Apple Pay o consulta con tu banco.",
    "coinbaseCardHardDeclined": "Tu banco rechazó esta tarjeta. Usa otra tarjeta en Apple Pay.",
    "coinbaseCardRiskDeclined": "No se pudo aprobar este pago. Prueba con otra tarjeta en Apple Pay.",
    "coinbaseInvalidCard": "Revisa la tarjeta y la dirección de facturación en Apple Pay e inténtalo de nuevo.",
    "coinbaseInsufficientBalance": "Esa tarjeta no tiene saldo suficiente para este depósito.",
    "coinbasePrepaidCard": "No se aceptan tarjetas prepago. Usa una tarjeta de débito en Apple Pay.",
    "coinbaseRegionUnsupported": "Los depósitos con tarjeta no están disponibles en tu ubicación.",
    "coinbasePermissionDenied": "Este método de pago no está disponible en tu cuenta.",
    "coinbaseWeeklyLimit": "Esto superaría tu límite semanal de depósitos con tarjeta. Prueba con un importe menor.",
    "coinbaseLifetimeCount": "Has usado todos los depósitos con tarjeta disponibles sin una cuenta de Coinbase.",
    "coinbaseDailyCount": "Has alcanzado el límite de depósitos con tarjeta de hoy. Inténtalo mañana.",
    "coinbaseBillingZip": "El código postal de facturación no coincide con tu tarjeta. Revísalo e inténtalo de nuevo.",
    "coinbaseBillingAddress": "La dirección de facturación está incompleta. Revísala e inténtalo de nuevo.",
    "coinbaseBillingName": "No se aceptó el nombre del titular. Revísalo e inténtalo de nuevo.",
    "coinbaseSessionExpired": "Esta sesión de pago caducó. Vuelve a iniciar el depósito.",
    "coinbaseNetworkUnsupported": "Esta red no está disponible en tu ubicación.",
    "coinbaseAssetUnsupported": "Este token no está disponible en tu ubicación.",
    "coinbaseProviderError": "Coinbase no pudo completar esto. Inténtalo de nuevo en un momento.",
    "coinbaseBuyFailed": "No se pudo completar la compra. No se realizó ningún cargo a tu tarjeta.",
    "coinbaseSendFailed": "No se pudo entregar el depósito. Se reembolsará el importe a tu tarjeta.",
    "coinbaseAvsFailed": "No se pudo verificar tu dirección de facturación. Compruébala con tu banco e inténtalo de nuevo.",
    "cancelled": "Depósito cancelado",
    "sessionExpired": "Tu sesión expiró. Inicia sesión de nuevo para continuar con el depósito.",
    "accountIneligibleTitle": "Los depósitos no están disponibles para esta cuenta",
    "accountIneligibleDetail": "Contacta con soporte si crees que es un error."
  },
  "fops": {
    "bankTransferSubtitle": "Límite de {{limit}} · 1-2 días",
    "bankTransferTime": "1-2 días",
    "instant": "Instantáneo",
    "limit": "Límite de {{limit}}"
  },
  "networks": {
    "chainFallback": "Cadena {{chainId}}",
    "minimum": "${{min}} mínimo"
  },
  "qrCode": {
    "title": "Código QR"
  },
  "selectChain": {
    "subtitle": "Elige una red desde la que depositar",
    "title": "Depositar cripto"
  },
  "selectMethod": {
    "crypto": "Cripto",
    "depositTo": "Depositar en",
    "errorMessage": "Hubo un problema al cargar los datos.\nRevisa tu conexión a internet e intenta nuevamente.",
    "errorTitle": "Algo salió mal",
    "loadingMethods": "Cargando métodos de pago",
    "noLimit": "Sin límite",
    "payWith": "Pagar con",
    "title": "Agregar dinero"
  },
  "selectReceiveToken": {
    "availableTokens": "Tokens disponibles",
    "moreTokens_many": "+{{count}} tokens",
    "moreTokens_one": "+{{count}} token",
    "moreTokens_other": "+{{count}} tokens",
    "searchTokens": "Busca un token",
    "selectChain": "Selecciona la red",
    "selectToken": "Selecciona el token",
    "title": "Token y red de recepción"
  },
  "transferCrypto": {
    "changeChain": "Cambiar cadena",
    "depositAddressLabel": "Tu dirección de depósito",
    "generating": "Generando…",
    "selectedChain": "Cadena seleccionada",
    "share": "Compartir",
    "shareAddress": "Compartir dirección",
    "showQrCode": "Mostrar código QR",
    "title": "Transferir cripto"
  },
  "withdraw": {
    "belowMinimumMessage": "Tu saldo está por debajo del mínimo para un retiro en efectivo.",
    "belowMinimumTitle": "Saldo insuficiente",
    "cashMethodsError": "No se pudieron cargar los métodos de retiro en efectivo. Aún puedes retirar con cripto.",
    "noCashMethods": "Los métodos de retiro como banco y tarjeta no están disponibles en tu región. Aún puedes retirar con cripto.",
    "title": "Retirar",
    "unavailableMessage": "Los retiros en efectivo no están disponibles en tu región en este momento.",
    "unavailableTitle": "Retiros no disponibles"
  },
  "withdrawAddress": {
    "breakdown": "Recibirás aproximadamente {{amount}}. Puede variar ligeramente según las condiciones de la red. Esta operación no se ejecutará a un precio inferior a {{minimum}}. Tu transacción debería completarse en unos segundos.",
    "breakdownTitle": "Detalle de la transacción",
    "clear": "Borrar",
    "detected": "Cartera detectada",
    "notFound": "No se encontró ninguna cartera",
    "paste": "Pegar",
    "requested": "Retiro solicitado",
    "title": "Retirar {{amount}}",
    "useConnected": "Usar conectada",
    "withdrawNow": "Retirar ahora",
    "withdrawing": "Retirando",
    "withdrew": "Retirado",
    "youllReceive": "Recibirás"
  },
  "withdrawAmount": {
    "amountLabel": "Importe",
    "delete": "Borrar",
    "swapDenomination": "Cambiar entre dólares y tokens",
    "useMax": "Usar máx."
  },
  "withdrawCrypto": {
    "aboveBalance": "Saldo insuficiente",
    "addressPlaceholder": "Dirección de la cartera",
    "available": "{{amount}} {{symbol}} disponibles",
    "belowFee": "El importe debe ser mayor que la comisión de {{amount}}",
    "belowMinimum": "El Monto Mínimo es {{amount}}",
    "ctaInvalidForChain": "La dirección no es válida en esta red",
    "ctaMaxExceeded": "Monto máximo excedido",
    "ctaRecipientSameAsSource": "Elige otra dirección",
    "ctaSelectDestination": "Selecciona un destino",
    "errorGeneric": "El retiro falló. Inténtalo nuevamente.",
    "errorInsufficientGas": "Gas insuficiente para esta transacción.",
    "errorSwitchChain": "No se puede cambiar de red. Asegúrate de que tu billetera soporte la red.",
    "failedMessage": "{{amount}} no llegó al destinatario. Contacta con soporte si los fondos no regresan.",
    "failedTitle": "La retirada no se completó",
    "max": "Máx.",
    "methodSubtitle": "Sin límite",
    "methodTitle": "Dirección cripto",
    "quoteFailed": "Error al obtener la cotización de intercambio. Por favor intenta nuevamente.",
    "receiveAs": "Recibir como",
    "refundedMessage": "{{amount}} se devolvió a tu monedero.",
    "riskyAddress": "Esta dirección de billetera no puede ser usada debido a restricciones.",
    "selectSource": "Seleccionar origen",
    "sendFrom": "Retirar desde",
    "successPendingMessage": "{{amount}} se está liquidando en la cadena. Puedes cerrar esto.",
    "successPendingTitle": "Retiro enviado",
    "title": "Retirar cripto",
    "unsupportedRecipient": "Dirección de destinatario no soportada"
  },
  "withdrawLighter": {
    "delayHours": "{{hours}} h",
    "delayHoursMinutes": "{{hours}} h {{minutes}} min",
    "delayMinutes": "{{minutes}} min",
    "delaySecond": "1 segundo",
    "delaySeconds": "{{seconds}} segundos",
    "fastDisclaimer": "Solo USDC Perps · Múltiples cadenas · Instantáneo",
    "fastDisclaimerUnified": "Solo USDC · Múltiples cadenas · Instantáneo",
    "methodFast": "Rápido",
    "methodSecure": "Puente Nativo",
    "secureDisclaimer": "Todos los tokens · Solo cadena Ethereum · {{delay}}",
    "secureFallbackDelay": "60+ minutos"
  },
  "withdrawNado": {
    "errorAmountTooLow": "El monto es demasiado bajo para cubrir la comisión de retiro de Nado.",
    "errorBalanceChanged": "Tu saldo retirable cambió. Toca Máx e inténtalo nuevamente.",
    "errorInvalidNonce": "Esta solicitud de retiro expiró. Inténtalo nuevamente.",
    "errorNetwork": "No se puede conectar con Nado en este momento. Inténtalo nuevamente.",
    "errorNoPriorDeposit": "Deposita en Nado antes de retirar.",
    "errorRateLimited": "Demasiadas solicitudes. Espera un momento e inténtalo nuevamente.",
    "errorSignerMismatch": "Vuelve a la billetera propietaria de esta cuenta de Nado para retirar.",
    "errorUnconfirmed": "No pudimos confirmar tu retiro. Revisa tu saldo de Nado antes de volver a intentarlo.",
    "errorWithdrawRisk": "Se alcanzó el límite de retiro de 24 horas de Nado. Inténtalo más tarde."
  },
  "paymentMethods": {
    "applePay": "Apple Pay",
    "card": "Tarjeta"
  },
  "lockedTransfer": {
    "amountInfoTitle": "Importe a enviar",
    "amountInfoDescription": "Este es el importe que debes enviar para depositar {{amount}}. Los fondos enviados por encima de este importe no se depositarán y necesitarás ayuda del equipo de soporte para recuperarlos.",
    "amountLoading": "Calculando…",
    "amountUnavailable": "Importe no disponible",
    "title": "Depositar criptomonedas",
    "send": "Enviar",
    "amount": "Importe",
    "address": "Dirección de depósito de un solo uso",
    "copyAmount": "Copiar importe",
    "amountCopied": "Importe copiado",
    "showFullAddress": "Mostrar dirección completa",
    "tokenOnChain": "{{token}} en {{chain}}"
  },
  "selectAsset": {
    "emptyChains": "No hay redes compatibles disponibles",
    "combinedTitle": "Token y red de envío",
    "title": "Selecciona un activo",
    "empty": "No hay activos compatibles disponibles"
  }
}
